export default {
  "config": {
    "trial": "tones-3",
    "id": "24h-sbp",
    "type": "line",
    "title": "Effects of Solriamfetol on SBP as Measured by 24 h ABPM<sup>26</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ],
      "padding": 0.1,
      "label": {
        "text": "Time of day"
      },
      "overrides": {
        "1": "6 AM -<br>8 AM",
        "2": "8 AM -<br>10 AM",
        "3": "10 AM -<br>12 PM",
        "4": "12 PM -<br>2 PM",
        "5": "2 PM -<br>4 PM",
        "6": "4 PM -<br>6 PM",
        "7": "6 PM -<br>8 PM",
        "8": "8 PM -<br>10 PM",
        "9": "10 PM -<br>12 AM",
        "10": "12 AM -<br>2 AM",
        "11": "2 AM -<br>4 AM",
        "12": "4 AM -<br>6 AM"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 90,
      "high": 150,
      "inc": 10,
      "label": {
        "text": [
          "SBP mean (SD), mmHg"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo-screening",
        "label": "Placebo at screening",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo at screening"
      },
      {
        "entry": "pbo-w8",
        "label": "Placebo at week 8",
        "color": "#868686",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Placebo at week 8"
      },
      {
        "entry": "sol-375-screening",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> at screening",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg at screening"
      },
      {
        "entry": "sol-375-w8",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> at week 8",
        "color": "#006e8a",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 37.5 mg at week 8"
      },
      {
        "entry": "sol-75-screening",
        "label": "Solriamfetol <no-break>75 mg</no-break> at screening",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg at screening"
      },
      {
        "entry": "sol-75-w8",
        "label": "Solriamfetol <no-break>75 mg</no-break> at week 8",
        "color": "#ffce00",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 75 mg at week 8"
      },
      {
        "entry": "sol-150-screening",
        "label": "Solriamfetol <no-break>150 mg</no-break> at screening",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg at screening"
      },
      {
        "entry": "sol-150-w8",
        "label": "Solriamfetol <no-break>150 mg</no-break> at week 8",
        "color": "#73cac3",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 150 mg at week 8"
      },
      {
        "entry": "sol-300-screening",
        "label": "Solriamfetol <no-break>300 mg</no-break> at screening",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg at screening"
      },
      {
        "entry": "sol-300-w8",
        "label": "Solriamfetol <no-break>300 mg</no-break> at week 8",
        "color": "#be5b92",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 300 mg at week 8"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "At week 8, increases in SBP were transient throughout the day."
    ],
    "useFootnoteTooltip": true,
    "trendLines": [],
    "tooltipHeaders": [
      "Treatment group",
      "mmHg"
    ],
    "nValueTable": {
      "type": "regular",
      "rows": 2,
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo-screening",
            "label": "Placebo at screening",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo at screening"
          },
          {
            "entry": "pbo-w8",
            "label": "Placebo at week 8",
            "color": "#868686",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Placebo at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375-screening",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> at screening",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg at screening"
          },
          {
            "entry": "sol-375-w8",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> at week 8",
            "color": "#006e8a",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 37.5 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75-screening",
            "label": "Solriamfetol <no-break>75 mg</no-break> at screening",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg at screening"
          },
          {
            "entry": "sol-75-w8",
            "label": "Solriamfetol <no-break>75 mg</no-break> at week 8",
            "color": "#ffce00",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 75 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150-screening",
            "label": "Solriamfetol <no-break>150 mg</no-break> at screening",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg at screening"
          },
          {
            "entry": "sol-150-w8",
            "label": "Solriamfetol <no-break>150 mg</no-break> at week 8",
            "color": "#73cac3",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 150 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300-screening",
            "label": "Solriamfetol <no-break>300 mg</no-break> at screening",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg at screening"
          },
          {
            "entry": "sol-300-w8",
            "label": "Solriamfetol <no-break>300 mg</no-break> at week 8",
            "color": "#be5b92",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 300 mg at week 8"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "pbo-screening",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo-screening",
          "color": "#868686",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Placebo at screening, mean",
          "tooltipLabel": "Placebo at screening",
          "points": [
            {
              "x": "1",
              "y": 120.74,
              "extreme": {
                "upper": 15.247,
                "lower": 15.247
              },
              "label": {
                "text": 120.74,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "2",
              "y": 124.97,
              "extreme": {
                "upper": 13.598,
                "lower": 13.598
              },
              "label": {
                "text": 124.97,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "3",
              "y": 127.71,
              "extreme": {
                "upper": 12.254,
                "lower": 12.254
              },
              "label": {
                "text": 127.71,
                "sup": null,
                "override": ""
              },
              "nvalue": 115
            },
            {
              "x": "4",
              "y": 129.75,
              "extreme": {
                "upper": 14.617,
                "lower": 14.617
              },
              "label": {
                "text": 129.75,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "5",
              "y": 128.84,
              "extreme": {
                "upper": 14.096,
                "lower": 14.096
              },
              "label": {
                "text": 128.84,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "6",
              "y": 127.46,
              "extreme": {
                "upper": 15.031,
                "lower": 15.031
              },
              "label": {
                "text": 127.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "7",
              "y": 129.11,
              "extreme": {
                "upper": 15.519,
                "lower": 15.519
              },
              "label": {
                "text": 129.11,
                "sup": null,
                "override": ""
              },
              "nvalue": 115
            },
            {
              "x": "8",
              "y": 126.17,
              "extreme": {
                "upper": 14.163,
                "lower": 14.163
              },
              "label": {
                "text": 126.17,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "9",
              "y": 123.79,
              "extreme": {
                "upper": 15.101,
                "lower": 15.101
              },
              "label": {
                "text": 123.79,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "10",
              "y": 116.86,
              "extreme": {
                "upper": 13.83,
                "lower": 13.83
              },
              "label": {
                "text": 116.86,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "11",
              "y": 112.79,
              "extreme": {
                "upper": 13.26,
                "lower": 13.26
              },
              "label": {
                "text": 112.79,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "12",
              "y": 114.77,
              "extreme": {
                "upper": 14.678,
                "lower": 14.678
              },
              "label": {
                "text": 114.77,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            }
          ]
        }
      ]
    },
    {
      "name": "pbo-w8",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo-w8",
          "color": "#868686",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Placebo at week 8, mean",
          "tooltipLabel": "Placebo at week 8",
          "points": [
            {
              "x": "1",
              "y": 118.68,
              "extreme": {
                "upper": 13.863,
                "lower": 13.863
              },
              "label": {
                "text": 118.68,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            },
            {
              "x": "2",
              "y": 124.87,
              "extreme": {
                "upper": 12.328,
                "lower": 12.328
              },
              "label": {
                "text": 124.87,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            },
            {
              "x": "3",
              "y": 127.93,
              "extreme": {
                "upper": 12.62,
                "lower": 12.62
              },
              "label": {
                "text": 127.93,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "4",
              "y": 127.39,
              "extreme": {
                "upper": 13.421,
                "lower": 13.421
              },
              "label": {
                "text": 127.39,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "5",
              "y": 128.45,
              "extreme": {
                "upper": 13.812,
                "lower": 13.812
              },
              "label": {
                "text": 128.45,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "6",
              "y": 129.55,
              "extreme": {
                "upper": 13.086,
                "lower": 13.086
              },
              "label": {
                "text": 129.55,
                "sup": null,
                "override": ""
              },
              "nvalue": 91
            },
            {
              "x": "7",
              "y": 130.15,
              "extreme": {
                "upper": 13.183,
                "lower": 13.183
              },
              "label": {
                "text": 130.15,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "8",
              "y": 129.87,
              "extreme": {
                "upper": 13.422,
                "lower": 13.422
              },
              "label": {
                "text": 129.87,
                "sup": null,
                "override": ""
              },
              "nvalue": 91
            },
            {
              "x": "9",
              "y": 122.51,
              "extreme": {
                "upper": 14.638,
                "lower": 14.638
              },
              "label": {
                "text": 122.51,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "10",
              "y": 116.33,
              "extreme": {
                "upper": 13.715,
                "lower": 13.715
              },
              "label": {
                "text": 116.33,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "11",
              "y": 112.93,
              "extreme": {
                "upper": 11.809,
                "lower": 11.809
              },
              "label": {
                "text": 112.93,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "12",
              "y": 113.59,
              "extreme": {
                "upper": 13.242,
                "lower": 13.242
              },
              "label": {
                "text": 113.59,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375-screening",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375-screening",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 37.5 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 37.5 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 120.05,
              "extreme": {
                "upper": 17.32,
                "lower": 17.32
              },
              "label": {
                "text": 120.05,
                "sup": null,
                "override": ""
              },
              "nvalue": 56
            },
            {
              "x": "2",
              "y": 126.35,
              "extreme": {
                "upper": 16.673,
                "lower": 16.673
              },
              "label": {
                "text": 126.35,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "3",
              "y": 127.46,
              "extreme": {
                "upper": 15.764,
                "lower": 15.764
              },
              "label": {
                "text": 127.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 53
            },
            {
              "x": "4",
              "y": 127.64,
              "extreme": {
                "upper": 14.342,
                "lower": 14.342
              },
              "label": {
                "text": 127.64,
                "sup": null,
                "override": ""
              },
              "nvalue": 54
            },
            {
              "x": "5",
              "y": 128.47,
              "extreme": {
                "upper": 14.233,
                "lower": 14.233
              },
              "label": {
                "text": 128.47,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "6",
              "y": 128.83,
              "extreme": {
                "upper": 13.892,
                "lower": 13.892
              },
              "label": {
                "text": 128.83,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "7",
              "y": 126.97,
              "extreme": {
                "upper": 15.871,
                "lower": 15.871
              },
              "label": {
                "text": 126.97,
                "sup": null,
                "override": ""
              },
              "nvalue": 53
            },
            {
              "x": "8",
              "y": 126.25,
              "extreme": {
                "upper": 12.652,
                "lower": 12.652
              },
              "label": {
                "text": 126.25,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "9",
              "y": 122.41,
              "extreme": {
                "upper": 14.231,
                "lower": 14.231
              },
              "label": {
                "text": 122.41,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "10",
              "y": 117.37,
              "extreme": {
                "upper": 15.115,
                "lower": 15.115
              },
              "label": {
                "text": 117.37,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "11",
              "y": 114.93,
              "extreme": {
                "upper": 14.101,
                "lower": 14.101
              },
              "label": {
                "text": 114.93,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "12",
              "y": 115.7,
              "extreme": {
                "upper": 16.785,
                "lower": 16.785
              },
              "label": {
                "text": 115.7,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375-w8",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375-w8",
          "color": "#006e8a",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 37.5 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 37.5 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 119.42,
              "extreme": {
                "upper": 17.715,
                "lower": 17.715
              },
              "label": {
                "text": 119.42,
                "sup": null,
                "override": ""
              },
              "nvalue": 39
            },
            {
              "x": "2",
              "y": 128.07,
              "extreme": {
                "upper": 17.046,
                "lower": 17.046
              },
              "label": {
                "text": 128.07,
                "sup": null,
                "override": ""
              },
              "nvalue": 40
            },
            {
              "x": "3",
              "y": 128.47,
              "extreme": {
                "upper": 15.483,
                "lower": 15.483
              },
              "label": {
                "text": 128.47,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "4",
              "y": 127.82,
              "extreme": {
                "upper": 14.809,
                "lower": 14.809
              },
              "label": {
                "text": 127.82,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "5",
              "y": 126.54,
              "extreme": {
                "upper": 13.815,
                "lower": 13.815
              },
              "label": {
                "text": 126.54,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "6",
              "y": 129.09,
              "extreme": {
                "upper": 13.347,
                "lower": 13.347
              },
              "label": {
                "text": 129.09,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "7",
              "y": 128.12,
              "extreme": {
                "upper": 14.728,
                "lower": 14.728
              },
              "label": {
                "text": 128.12,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "8",
              "y": 126.48,
              "extreme": {
                "upper": 15.351,
                "lower": 15.351
              },
              "label": {
                "text": 126.48,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "9",
              "y": 120.5,
              "extreme": {
                "upper": 12.41,
                "lower": 12.41
              },
              "label": {
                "text": 120.5,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "10",
              "y": 115.52,
              "extreme": {
                "upper": 15.47,
                "lower": 15.47
              },
              "label": {
                "text": 115.52,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "11",
              "y": 115.27,
              "extreme": {
                "upper": 17.746,
                "lower": 17.746
              },
              "label": {
                "text": 115.27,
                "sup": null,
                "override": ""
              },
              "nvalue": 41
            },
            {
              "x": "12",
              "y": 113.74,
              "extreme": {
                "upper": 17.308,
                "lower": 17.308
              },
              "label": {
                "text": 113.74,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75-screening",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75-screening",
          "color": "#ffce00",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 75 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 75 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 117.08,
              "extreme": {
                "upper": 14.084,
                "lower": 14.084
              },
              "label": {
                "text": 117.08,
                "sup": null,
                "override": ""
              },
              "nvalue": 58
            },
            {
              "x": "2",
              "y": 122.23,
              "extreme": {
                "upper": 13.123,
                "lower": 13.123
              },
              "label": {
                "text": 122.23,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "3",
              "y": 124.97,
              "extreme": {
                "upper": 13.19,
                "lower": 13.19
              },
              "label": {
                "text": 124.97,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "4",
              "y": 124.1,
              "extreme": {
                "upper": 14.167,
                "lower": 14.167
              },
              "label": {
                "text": 124.1,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "5",
              "y": 124.45,
              "extreme": {
                "upper": 14.704,
                "lower": 14.704
              },
              "label": {
                "text": 124.45,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "6",
              "y": 122.86,
              "extreme": {
                "upper": 12.123,
                "lower": 12.123
              },
              "label": {
                "text": 122.86,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "7",
              "y": 126.16,
              "extreme": {
                "upper": 14.63,
                "lower": 14.63
              },
              "label": {
                "text": 126.16,
                "sup": null,
                "override": ""
              },
              "nvalue": 61
            },
            {
              "x": "8",
              "y": 125.36,
              "extreme": {
                "upper": 13.319,
                "lower": 13.319
              },
              "label": {
                "text": 125.36,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "9",
              "y": 121.09,
              "extreme": {
                "upper": 13.526,
                "lower": 13.526
              },
              "label": {
                "text": 121.09,
                "sup": null,
                "override": ""
              },
              "nvalue": 61
            },
            {
              "x": "10",
              "y": 114.39,
              "extreme": {
                "upper": 13.318,
                "lower": 13.318
              },
              "label": {
                "text": 114.39,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "11",
              "y": 112.4,
              "extreme": {
                "upper": 13.855,
                "lower": 13.855
              },
              "label": {
                "text": 112.4,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "12",
              "y": 112.01,
              "extreme": {
                "upper": 14.477,
                "lower": 14.477
              },
              "label": {
                "text": 112.01,
                "sup": null,
                "override": ""
              },
              "nvalue": 58
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75-w8",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75-w8",
          "color": "#ffce00",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 75 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 75 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 119.5,
              "extreme": {
                "upper": 14.326,
                "lower": 14.326
              },
              "label": {
                "text": 119.5,
                "sup": null,
                "override": ""
              },
              "nvalue": 51
            },
            {
              "x": "2",
              "y": 126.85,
              "extreme": {
                "upper": 14.418,
                "lower": 14.418
              },
              "label": {
                "text": 126.85,
                "sup": null,
                "override": ""
              },
              "nvalue": 50
            },
            {
              "x": "3",
              "y": 128.37,
              "extreme": {
                "upper": 14.281,
                "lower": 14.281
              },
              "label": {
                "text": 128.37,
                "sup": null,
                "override": ""
              },
              "nvalue": 51
            },
            {
              "x": "4",
              "y": 129.92,
              "extreme": {
                "upper": 14.616,
                "lower": 14.616
              },
              "label": {
                "text": 129.92,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "5",
              "y": 126.54,
              "extreme": {
                "upper": 17.45,
                "lower": 17.45
              },
              "label": {
                "text": 126.54,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "6",
              "y": 128.03,
              "extreme": {
                "upper": 16.44,
                "lower": 16.44
              },
              "label": {
                "text": 128.03,
                "sup": null,
                "override": ""
              },
              "nvalue": 48
            },
            {
              "x": "7",
              "y": 130.84,
              "extreme": {
                "upper": 14.431,
                "lower": 14.431
              },
              "label": {
                "text": 130.84,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "8",
              "y": 129.23,
              "extreme": {
                "upper": 15.884,
                "lower": 15.884
              },
              "label": {
                "text": 129.23,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "9",
              "y": 122.35,
              "extreme": {
                "upper": 14.575,
                "lower": 14.575
              },
              "label": {
                "text": 122.35,
                "sup": null,
                "override": ""
              },
              "nvalue": 48
            },
            {
              "x": "10",
              "y": 117.22,
              "extreme": {
                "upper": 14.595,
                "lower": 14.595
              },
              "label": {
                "text": 117.22,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "11",
              "y": 113.64,
              "extreme": {
                "upper": 14.241,
                "lower": 14.241
              },
              "label": {
                "text": 113.64,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "12",
              "y": 116.91,
              "extreme": {
                "upper": 13.617,
                "lower": 13.617
              },
              "label": {
                "text": 116.91,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150-screening",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150-screening",
          "color": "#73cac3",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 150 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 150 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 117.35,
              "extreme": {
                "upper": 16.219,
                "lower": 16.219
              },
              "label": {
                "text": 117.35,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "2",
              "y": 123.92,
              "extreme": {
                "upper": 15.77,
                "lower": 15.77
              },
              "label": {
                "text": 123.92,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "3",
              "y": 125.83,
              "extreme": {
                "upper": 14.173,
                "lower": 14.173
              },
              "label": {
                "text": 125.83,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "4",
              "y": 127.67,
              "extreme": {
                "upper": 15.419,
                "lower": 15.419
              },
              "label": {
                "text": 127.67,
                "sup": null,
                "override": ""
              },
              "nvalue": 112
            },
            {
              "x": "5",
              "y": 126.55,
              "extreme": {
                "upper": 15.604,
                "lower": 15.604
              },
              "label": {
                "text": 126.55,
                "sup": null,
                "override": ""
              },
              "nvalue": 112
            },
            {
              "x": "6",
              "y": 125.11,
              "extreme": {
                "upper": 15.699,
                "lower": 15.699
              },
              "label": {
                "text": 125.11,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            },
            {
              "x": "7",
              "y": 127.29,
              "extreme": {
                "upper": 15.413,
                "lower": 15.413
              },
              "label": {
                "text": 127.29,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "8",
              "y": 126.77,
              "extreme": {
                "upper": 15.661,
                "lower": 15.661
              },
              "label": {
                "text": 126.77,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "9",
              "y": 122.29,
              "extreme": {
                "upper": 14.857,
                "lower": 14.857
              },
              "label": {
                "text": 122.29,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            },
            {
              "x": "10",
              "y": 115.65,
              "extreme": {
                "upper": 14.259,
                "lower": 14.259
              },
              "label": {
                "text": 115.65,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "11",
              "y": 112.77,
              "extreme": {
                "upper": 14.985,
                "lower": 14.985
              },
              "label": {
                "text": 112.77,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "12",
              "y": 114.32,
              "extreme": {
                "upper": 15.978,
                "lower": 15.978
              },
              "label": {
                "text": 114.32,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150-w8",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150-w8",
          "color": "#73cac3",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 150 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 150 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 118.18,
              "extreme": {
                "upper": 17.793,
                "lower": 17.793
              },
              "label": {
                "text": 118.18,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "2",
              "y": 124.66,
              "extreme": {
                "upper": 13.292,
                "lower": 13.292
              },
              "label": {
                "text": 124.66,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "3",
              "y": 127.49,
              "extreme": {
                "upper": 14.415,
                "lower": 14.415
              },
              "label": {
                "text": 127.49,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "4",
              "y": 127.99,
              "extreme": {
                "upper": 14.592,
                "lower": 14.592
              },
              "label": {
                "text": 127.99,
                "sup": null,
                "override": ""
              },
              "nvalue": 98
            },
            {
              "x": "5",
              "y": 126.08,
              "extreme": {
                "upper": 13.629,
                "lower": 13.629
              },
              "label": {
                "text": 126.08,
                "sup": null,
                "override": ""
              },
              "nvalue": 98
            },
            {
              "x": "6",
              "y": 127.74,
              "extreme": {
                "upper": 12.893,
                "lower": 12.893
              },
              "label": {
                "text": 127.74,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "7",
              "y": 125.71,
              "extreme": {
                "upper": 12.86,
                "lower": 12.86
              },
              "label": {
                "text": 125.71,
                "sup": null,
                "override": ""
              },
              "nvalue": 100
            },
            {
              "x": "8",
              "y": 124.29,
              "extreme": {
                "upper": 13.34,
                "lower": 13.34
              },
              "label": {
                "text": 124.29,
                "sup": null,
                "override": ""
              },
              "nvalue": 102
            },
            {
              "x": "9",
              "y": 121.22,
              "extreme": {
                "upper": 12.461,
                "lower": 12.461
              },
              "label": {
                "text": 121.22,
                "sup": null,
                "override": ""
              },
              "nvalue": 100
            },
            {
              "x": "10",
              "y": 115.42,
              "extreme": {
                "upper": 13.479,
                "lower": 13.479
              },
              "label": {
                "text": 115.42,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            },
            {
              "x": "11",
              "y": 112.67,
              "extreme": {
                "upper": 13.878,
                "lower": 13.878
              },
              "label": {
                "text": 112.67,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            },
            {
              "x": "12",
              "y": 114.23,
              "extreme": {
                "upper": 15.731,
                "lower": 15.731
              },
              "label": {
                "text": 114.23,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300-screening",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300-screening",
          "color": "#be5b92",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 300 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 300 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 118.29,
              "extreme": {
                "upper": 13.469,
                "lower": 13.469
              },
              "label": {
                "text": 118.29,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "2",
              "y": 124.14,
              "extreme": {
                "upper": 15.581,
                "lower": 15.581
              },
              "label": {
                "text": 124.14,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "3",
              "y": 127.9,
              "extreme": {
                "upper": 14.975,
                "lower": 14.975
              },
              "label": {
                "text": 127.9,
                "sup": null,
                "override": ""
              },
              "nvalue": 106
            },
            {
              "x": "4",
              "y": 127.57,
              "extreme": {
                "upper": 15.045,
                "lower": 15.045
              },
              "label": {
                "text": 127.57,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "5",
              "y": 127.31,
              "extreme": {
                "upper": 15.299,
                "lower": 15.299
              },
              "label": {
                "text": 127.31,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "6",
              "y": 127.15,
              "extreme": {
                "upper": 13.172,
                "lower": 13.172
              },
              "label": {
                "text": 127.15,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "7",
              "y": 128.82,
              "extreme": {
                "upper": 14.079,
                "lower": 14.079
              },
              "label": {
                "text": 128.82,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "8",
              "y": 129.05,
              "extreme": {
                "upper": 14.847,
                "lower": 14.847
              },
              "label": {
                "text": 129.05,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "9",
              "y": 124.32,
              "extreme": {
                "upper": 15.014,
                "lower": 15.014
              },
              "label": {
                "text": 124.32,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "10",
              "y": 115.84,
              "extreme": {
                "upper": 14.227,
                "lower": 14.227
              },
              "label": {
                "text": 115.84,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "11",
              "y": 113.14,
              "extreme": {
                "upper": 14.85,
                "lower": 14.85
              },
              "label": {
                "text": 113.14,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "12",
              "y": 112.37,
              "extreme": {
                "upper": 14.938,
                "lower": 14.938
              },
              "label": {
                "text": 112.37,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300-w8",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300-w8",
          "color": "#be5b92",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 300 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 300 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 123.36,
              "extreme": {
                "upper": 21.316,
                "lower": 21.316
              },
              "label": {
                "text": 123.36,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "2",
              "y": 130.59,
              "extreme": {
                "upper": 19.487,
                "lower": 19.487
              },
              "label": {
                "text": 130.59,
                "sup": null,
                "override": ""
              },
              "nvalue": 84
            },
            {
              "x": "3",
              "y": 131.61,
              "extreme": {
                "upper": 17.097,
                "lower": 17.097
              },
              "label": {
                "text": 131.61,
                "sup": null,
                "override": ""
              },
              "nvalue": 84
            },
            {
              "x": "4",
              "y": 132.11,
              "extreme": {
                "upper": 18.506,
                "lower": 18.506
              },
              "label": {
                "text": 132.11,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "5",
              "y": 130.95,
              "extreme": {
                "upper": 18.385,
                "lower": 18.385
              },
              "label": {
                "text": 130.95,
                "sup": null,
                "override": ""
              },
              "nvalue": 88
            },
            {
              "x": "6",
              "y": 129.22,
              "extreme": {
                "upper": 14.564,
                "lower": 14.564
              },
              "label": {
                "text": 129.22,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "7",
              "y": 131.42,
              "extreme": {
                "upper": 15.614,
                "lower": 15.614
              },
              "label": {
                "text": 131.42,
                "sup": null,
                "override": ""
              },
              "nvalue": 86
            },
            {
              "x": "8",
              "y": 129.79,
              "extreme": {
                "upper": 14.907,
                "lower": 14.907
              },
              "label": {
                "text": 129.79,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "9",
              "y": 125.74,
              "extreme": {
                "upper": 20.204,
                "lower": 20.204
              },
              "label": {
                "text": 125.74,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "10",
              "y": 117.94,
              "extreme": {
                "upper": 18.343,
                "lower": 18.343
              },
              "label": {
                "text": 117.94,
                "sup": null,
                "override": ""
              },
              "nvalue": 88
            },
            {
              "x": "11",
              "y": 114.77,
              "extreme": {
                "upper": 18.782,
                "lower": 18.782
              },
              "label": {
                "text": 114.77,
                "sup": null,
                "override": ""
              },
              "nvalue": 85
            },
            {
              "x": "12",
              "y": 116.67,
              "extreme": {
                "upper": 19.32,
                "lower": 19.32
              },
              "label": {
                "text": 116.67,
                "sup": null,
                "override": ""
              },
              "nvalue": 83
            }
          ]
        }
      ]
    }
  ]
};